import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { inject } from 'vue';
import type { FaqContent, QuestionModel, Topic } from '@src/view_models/faq';
import { QUERY_STRING_INJECTION_KEY } from '@src/util/createCampaignQueryString';
import { appendCampaignQueryParams } from '@src/util/append_campaign_query_params';
import ContentCard from '@src/components/patterns/ContentCard.vue';
import Accordion from '@src/components/patterns/Accordion.vue';
import AccordionItem from '@src/components/patterns/AccordionItem.vue';

interface Props {
	content: FaqContent;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Faq',
  props: {
    content: {}
  },
  setup(__props: any) {

const props = __props;
const campaignParams = inject( QUERY_STRING_INJECTION_KEY, '' );

const getQuestionsByTopic = ( topic: Topic ): QuestionModel[] => {
	return props.content.questions.filter( ( question ) =>
		question.topic.split( ',' ).indexOf( topic.id ) !== -1
	);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentCard, null, {
    heading: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('faq_headline')), 1)
    ]),
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content.topics, (topic, index) => {
        return (_openBlock(), _createElementBlock("section", {
          key: index,
          class: "accordion-group flow"
        }, [
          _createElementVNode("h2", null, _toDisplayString(topic.name), 1),
          _createVNode(Accordion, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getQuestionsByTopic( topic ), (content, itemIndex) => {
                return (_openBlock(), _createBlock(AccordionItem, {
                  key: topic.id + itemIndex
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(content.question), 1)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _unref(appendCampaignQueryParams)( content.visibleText, _unref(campaignParams) )
                    }, null, 8, _hoisted_1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})